/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListActivities200ResponseLinks } from './ListActivities200ResponseLinks';
import {
    ListActivities200ResponseLinksFromJSON,
    ListActivities200ResponseLinksFromJSONTyped,
    ListActivities200ResponseLinksToJSON,
    ListActivities200ResponseLinksToJSONTyped,
} from './ListActivities200ResponseLinks';
import type { ListActivities200ResponseDataInner } from './ListActivities200ResponseDataInner';
import {
    ListActivities200ResponseDataInnerFromJSON,
    ListActivities200ResponseDataInnerFromJSONTyped,
    ListActivities200ResponseDataInnerToJSON,
    ListActivities200ResponseDataInnerToJSONTyped,
} from './ListActivities200ResponseDataInner';
import type { ListActivities200ResponseMeta } from './ListActivities200ResponseMeta';
import {
    ListActivities200ResponseMetaFromJSON,
    ListActivities200ResponseMetaFromJSONTyped,
    ListActivities200ResponseMetaToJSON,
    ListActivities200ResponseMetaToJSONTyped,
} from './ListActivities200ResponseMeta';

/**
 * 
 * @export
 * @interface ListActivities200Response
 */
export interface ListActivities200Response {
    /**
     * 
     * @type {Array<ListActivities200ResponseDataInner>}
     * @memberof ListActivities200Response
     */
    data?: Array<ListActivities200ResponseDataInner>;
    /**
     * 
     * @type {ListActivities200ResponseLinks}
     * @memberof ListActivities200Response
     */
    links?: ListActivities200ResponseLinks;
    /**
     * 
     * @type {ListActivities200ResponseMeta}
     * @memberof ListActivities200Response
     */
    meta?: ListActivities200ResponseMeta;
}

/**
 * Check if a given object implements the ListActivities200Response interface.
 */
export function instanceOfListActivities200Response(value: object): value is ListActivities200Response {
    return true;
}

export function ListActivities200ResponseFromJSON(json: any): ListActivities200Response {
    return ListActivities200ResponseFromJSONTyped(json, false);
}

export function ListActivities200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListActivities200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ListActivities200ResponseDataInnerFromJSON)),
        'links': json['links'] == null ? undefined : ListActivities200ResponseLinksFromJSON(json['links']),
        'meta': json['meta'] == null ? undefined : ListActivities200ResponseMetaFromJSON(json['meta']),
    };
}

export function ListActivities200ResponseToJSON(json: any): ListActivities200Response {
    return ListActivities200ResponseToJSONTyped(json, false);
}

export function ListActivities200ResponseToJSONTyped(value?: ListActivities200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ListActivities200ResponseDataInnerToJSON)),
        'links': ListActivities200ResponseLinksToJSON(value['links']),
        'meta': ListActivities200ResponseMetaToJSON(value['meta']),
    };
}

